import { useMutation } from "react-query";
import { validateCoderRole } from "components/coding/lib/codingData";

export const useValidateCoderRole = () => {
    return useMutation(({ taskKey }) => validateCoderRole(taskKey));
};
